import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { emitter } from './Services/EventEmitter';
import { Forbidden } from './Pages/Forbidden/Forbidden';
import { applyDecorators } from "@app/Helpers/Decorator";

export interface IEdwRouteRouteProps extends RouteProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: any;
    additionalProps?: { [key: string]: unknown };
}

@observer
export class EdwRoute extends React.Component<IEdwRouteRouteProps> {
    private _store: EdwRouteStore;

    constructor(props: IEdwRouteRouteProps) {
        super(props);
        applyDecorators(this);
        this._store = new EdwRouteStore();
    }

    componentDidUpdate(prevProps: IEdwRouteRouteProps) {
        if (prevProps.path !== this.props.path) {
            this._store.clearError();
        }
    }

    render() {
        const { component: Component, additionalProps, ...rest } = this.props;

        if (this._store.hasErrors) {
            return <Forbidden url={this._store.url} method={this._store.method} error={this._store.error} />;
        } else {
            return <Route {...rest} render={(routeProps) => <Component {...routeProps} {...additionalProps} />} />;
        }
    }
}

class EdwRouteStore {
    @observable hasErrors: boolean = false;
    @observable url: null | string = null;
    @observable method: null | string = null;
    @observable error: null | string = null;

    constructor() {
        applyDecorators(this);
        emitter.on('notify-error-403', this.onErrorHandler);
    }

    unload() {
        emitter.off('notify-error-403', this.onErrorHandler);
    }

    @action.bound
    onErrorHandler(details: { config?: { url: string, method: string }, response?: { data?: { error: string } } }) {
        this.hasErrors = true;
        this.url = details.config?.url || null;
        this.method = details.config?.method || null;
        this.error = details.response?.data?.error || null;
    }

    @action.bound
    clearError() {
        this.hasErrors = false;
        this.url = null;
        this.method = null;
        this.error = null;
    }
}
